<template>
    <NuxtLink class="layout-course-lesson-tile" :class="cardClasses" :to="lesson.lesson_route">
        <div class="grid grid-cols-12 px-4 py-3">
            <div class="col-span-11 flex flex-1 items-center">
                <ContentCardHeading
                    headingComponent="p"
                    :heading="lesson.lesson_title"
                    :truncated="true"
                ></ContentCardHeading>
            </div>
            <div class="col-span-1 ml-auto">
                <div class="ml-auto">
                    <IconLockedOutline v-if="!isPremiumMember && lesson.lesson_locked" class="text-zinc-400"></IconLockedOutline>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="ml-auto h-6 w-6 text-zinc-400">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z" />
                    </svg>
                </div>
            </div>
        </div>
    </NuxtLink>
</template>

<script>

export default {
    name: 'LayoutCourseLessonTile',
    props: {
        lesson: {
            required: true,
            type: Object,
            default: null,
        },
        isPremiumMember: {
            required: false,
            type: [Boolean, Number],
            default: false,
        }
    },
    computed: {
        component () {
            return 'div';
        },
        cardClasses () {
            const cls = {};
            cls['col-span-1 flex flex-col divide-y divide-gray-200 rounded-lg overflow-hidden bg-white'] = true;
            cls['hover:bg-zinc-100'] = !!this.lesson.lesson_route;
            return cls;
        },
    },
};
</script>
